import { useState } from "react";
import "./Dropdown.css";

function Dropdown({ title, children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="dropdown">
      <button
        className="dropdown-header"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`chevron ${isOpen ? "open" : ""}`}>▼</span>
        <span className="title">{title}</span>
      </button>

      {isOpen && <div className="dropdown-content">{children}</div>}
    </div>
  );
}

export default Dropdown;
